import { AxiosInstance } from 'axios';

import { OrdersColumnsEnum } from '../../../../../admin/columns/orders-columns.enum';
import { axios } from '../../../../api/axios-instance';
import { ordersEndpoints } from '../../../../constants';
import { DateFilter } from '../../../../enum/date-filter.enum';
import { ProgressStatusesEnum } from '../../../../enum/progress-statuses.enum';
import { DeleteItemsInput } from '../../../../types';
import { PaginationRequest } from '../../../../types/pagination-request';
import { SortRequest } from '../../../../types/sort-request';
import { GetAllOrdersResponse, IOrder } from '../../entities/order';
import {
  AddNewOrderInput,
  BulkUpdateOrdersInput,
  UpdateOrderInput,
} from '../../schemas/order.schema';

class OrdersApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  addNewOrder = async (input: AddNewOrderInput): Promise<IOrder> =>
    this.#requestInstance.post(ordersEndpoints.orders, input);

  deleteOrder = async (orderId: number): Promise<void> =>
    this.#requestInstance.delete(ordersEndpoints.ordersId(orderId));

  getOrders = async (
    data?: PaginationRequest & SortRequest<OrdersColumnsEnum> & { status: ProgressStatusesEnum }
  ): Promise<GetAllOrdersResponse> =>
    this.#requestInstance.get(ordersEndpoints.orders, { params: data });

  getAllOrdersById = async (userId: number, order: DateFilter): Promise<GetAllOrdersResponse> =>
    this.#requestInstance.get(ordersEndpoints.getAllOrdersById(userId), { params: { order } });

  deleteManyOrders = async (input: DeleteItemsInput): Promise<void> =>
    this.#requestInstance.delete(ordersEndpoints.orders, { data: input });

  updateManyOrders = async (input: BulkUpdateOrdersInput): Promise<void> =>
    this.#requestInstance.patch(ordersEndpoints.orders, input);

  updateOrder = async (input: UpdateOrderInput): Promise<void> =>
    this.#requestInstance.patch(ordersEndpoints.ordersId(input.id), input);
}

export const ordersApi = new OrdersApi(axios);
